import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import speedDate from 'speed-date';

let enFormatter = 'MM/DD/YYYY';
let otherFormatter = 'DD.MM.YYYY';

//Vue.use(Vuex);

export const store = Vuex.createStore({
    state: {
        apiUrl: "",
        checkAllEventDone: false,
        checkAllId: -1,
        countryUrl: "",
        countries: [],
        countriesLoaded: false,
        apiKey: "",
        hierarchyUrl: "",
        language: "",
        translatedLabels: "",
        conf: {},
        languages: {
            "fi": 0,
            "sv": 1,
            "en": 2
        },
        ids: [],
        name: "",
        searchTerm: "",
        countryLanguages: { fi: 'fi', sv: 'se', en: 'en' },
        exportFileName: "export",
        isSupervisedPage: false,
        searchHidden: false,
        currentPage: 0,
        itemsPerPage: 30,
        pageCount: 0,
        groupTree: [],
        groupDisplayMap: {},
        displayElement: {
            Telephone: 1,
            Telefax: 2,
            WWWAddress: 4,
            PostalAddress: 8,
            HeadOfficeAddress: 16,
            OfficeAddress: 32,
            VisitingAddress: 64,
            ConsumerComplaintsAddress: 128
        },
        searchParams: {
            Lang: "",
            CompanyName: ""
        },
        searching: false,
        errorMessage: false,
        noResults: false,
        supervisedEntitiesData: [],
        focusValue: [],
    },
    getters: {
        LocaleString: state => {
            let lang = state.conf.language;
            if (lang === "fi")
                return lang;
            else if (lang === "en")
                return "en-us";
            else if (lang === "sv")
                return "sv-se";
        },
        firstResult(state) {
            return state.supervisedEntitiesData[0].groupnumber;
        },

        OrganiseArray: state => {
            if (Array.isArray(original))
                return original.map(x => propsToLowerCase(x));
            if (typeof original === 'string' || typeof original === 'number')
                return original;
            if (original === null)
                return null;
            return Object.keys(original).reduce((newObj, key) => {
                let val = original[key];
                let newVal = (typeof val === 'object') ? propsToLowerCase(val) : val;
                newObj[key.toLowerCase()] = newVal;
                return newObj;
            }, {});
        },
        createServicesInCountry: state => {
            /*
            const _countries = Array.from(
                state.supervisedEntitiesData.reduce((map, obj) => {
                    if (!map.has(obj.countrycode)) {
                        map.set(obj.countrycode, obj);
                    }
                    return map;
                }, new Map())
            ).map(([countrycode, obj]) => obj);*/

            //const data = state.supervisedEntitiesData;
            const _countries = [];
            state.supervisedEntitiesData.forEach(function (ent) {
                if (ent.servicesincountry) {
                    //console.log(ent.servicesincountry);
                    _countries.push(ent.servicesincountry);
                }
            });

            return _countries;
        }
    },
    mutations: {

        setConf: (state, newConf) => {
            state.conf = window.conf;
            //state.conf = Object.assign({}, state.conf, newConf);
        },
        setCountries: (state, value) => {
            state.countries = value;
        },
        setCountriesLoaded: (state, value) => {
            state.countriesLoaded = value;
        },
        setLanguage: (state, value) => {
            state.language = value;
        },
        setSearching: (state, value) => {
            state.searching = value;
        },
        setSearchTerm: (state, value) => {
            state.searchTerm = value;
        },
        setSearchParams: (state, value) => {
            state.searchParams = value;
        },
        setGroupTree: (state, value) => {
            state.groupTree = value;
        },
        setIds: (state, value) => {
            state.ids = value;
        },
        setIsSupervisedPage: (state, value) => {
            state.isSupervisedPage = value;
        },
        setPageCount: (state, value) => {
            state.pageCount = value;
        },
        setSupervisedEntitiesData: (state, value) => {
            state.supervisedEntitiesData = value;
        },
        setNoResults: (state, value) => {
            state.noResults = value;
        },
        setErrorMessage: (state, value) => {
            state.errorMessage = value;
        },
        clearSearchParams: (state, value) => {
            state.searchParams = {};
        },
        setFocusValue: (state, value) => {
            if (state.focusValue.length == 2) {
                state.focusValue.pop();
                state.focusValue.unshift(value);
                //console.log("focus value ", state.focusValue);
            } else {
                state.focusValue.push(value);
                //console.log("focus value ", state.focusValue);
            }
        },
        setGroupDisplayMap: (state, value) => {
            state.groupDisplayMap = value;
        }
    },
    actions: {
        Init: ({ commit, state }, config) => {
            commit('setConf', config);

            

            if (state.conf.countryUrl != null && state.conf.countryUrl != "") {

                $.ajax({
                    method: "GET",
                    url: state.conf.countryUrl,
                    headers: {
                        "Ocp-Apim-Subscription-Key": state.conf.apiKey,
                        "Accept": "application/json"
                    },
                    traditional: true
                }).done((data,) => {
                    commit('setCountries', propsToLowerCase(data));
                    commit('setCountriesLoaded', true);
                }).fail(() => console.error("Could not load country names"))
            }

            $.ajax({
                method: "GET",
                url: state.conf.hierarchyUrl,
                headers: {
                    //"Ocp-Apim-Subscription-Key": groupNumber,
                    "Accept": "application/json"
                },
                traditional: true
            }).done((data,) => {

                commit('setGroupTree', data);
            }).fail(() => console.error("Could not load hierarchy tree"));

            if (state.conf.isSupervisedPage) {
                commit('setIsSupervisedPage', state.conf.isSupervisedPage)
            }

            // 1. Hae hierarchyData ja rakenna map
            $.ajax({
                url: state.conf.hierarchyUrl,
                method: "GET",
                headers: { "Ocp-Apim-Subscription-Key": window.conf.apiKey }
            }).done(hierarchyData => {
                const data = buildGroupDisplayMap(hierarchyData);
                commit('setGroupDisplayMap', data);
                console.log("vue groupDisplayMap built:", state.groupDisplayMap);

                // 2. Hae items data-API:sta
                $.ajax({
                    url: state.conf.apiUrl,
                    method: "GET",
                    headers: { "Ocp-Apim-Subscription-Key": state.conf.apiKey }
                }).done(itemsData => {
                    console.log("vue itemsData:", itemsData);

                }).fail(() => console.error("Could not load items data"));

            }).fail(() => console.error("Could not load hierarchy data"));

        },
        SearchItems: ({ state, commit, dispatch }) => {

            commit('setSearching', true);
            commit('setNoResults', false);
            commit('setErrorMessage', false); 
            commit('setSupervisedEntitiesData', []);

            let dataParams = {
                Lang: state.languages[state.conf.language],

            };

            if (state.ids && state.ids.length)
                dataParams['Groups'] = state.ids.filter(x => x !== state.checkAllId);
            if (state.searchTerm && state.searchTerm.length)
                dataParams['CompanyName'] = state.searchTerm;

            $.when($.ajax({
                method: "GET",
                url: state.conf.apiUrl,
                headers: {
                    "Ocp-Apim-Subscription-Key": state.conf.apiKey,
                    "Accept": "application/json"
                },
                data: dataParams,
                traditional: true
            }))
                .then(data => {
                    if (!Array.isArray(data)) {
                        return console.log("Data must be an array");
                    }

                    data = data.map(x => propsToLowerCase(x));
                    
                    data = sortAlphabetically(data, item => item.companyname);
                    
                    return data;
                })
                .then(data => {
                    commit('setSupervisedEntitiesData', data);
                    if (data.length === 0) { commit('setNoResults', true); }
                    commit('setSearching', false);
                    setTimeout(() => {
                        document.getElementById("vue-supervised-results").focus();

                    }, 500);
                    
                })
                .catch(error => {
                    commit('setSearching', false);
                    //errorDiv.show().text(translatedLabels.errorloadingdata);
                    commit('setErrorMessage', true); 
                    console.error(error);
                })

        },
        Search: (searchParams) => {
            return $.when($.ajax({
                method: "GET",
                url: state.conf.apiUrl,
                headers: {
                    "Ocp-Apim-Subscription-Key": apiKey,
                    "Accept": "application/json"
                },
                data: searchParams,
                traditional: true
            }))
        },
        propsToLowerCase: ({ state, commit, dispatch }, original) => {
            if (Array.isArray(original))
                return original.map(x => propsToLowerCase(x));
            if (typeof original === 'string' || typeof original === 'number')
                return original;
            if (original === null)
                return null;
            return Object.keys(original).reduce((newObj, key) => {
                let val = original[key];
                let newVal = (typeof val === 'object') ? propsToLowerCase(val) : val;
                newObj[key.toLowerCase()] = newVal;
                return newObj;
            }, {});
        },
        SortAlphabetically: ({ state, commit, dispatch }, list, propToSortBy) => {
            return list.sort((a, b) => {
                var x = propToSortBy(a).toLowerCase();
                var y = propToSortBy(b).toLowerCase();
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                return 0;
            })
        }

    }
})

const propsToLowerCase = (original) => {
    if (Array.isArray(original))
        return original.map(x => propsToLowerCase(x));
    if (typeof original === 'string' || typeof original === 'number')
        return original;
    if (original === null)
        return null;
    return Object.keys(original).reduce((newObj, key) => {
        let val = original[key];
        let newVal = (typeof val === 'object') ? propsToLowerCase(val) : val;
        newObj[key.toLowerCase()] = newVal;
        return newObj;
    }, {});
}

function sortAlphabetically(list, propToSortBy) {
    return list.sort((a, b) => {
        var x = propToSortBy(a).toLowerCase();
        var y = propToSortBy(b).toLowerCase();
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    })
};



function buildGroupDisplayMap(groups) {
    if (!groups) return;

    function displayMapBuilder(groups) {
        const arr = Array.isArray(groups) ? groups : [groups];

        arr.forEach(g => {

            const groupNumber = Number(g.groupNumber);
            if (!isNaN(groupNumber)) {
                gdMap[groupNumber] = Number(g.displayStyle) || 0;
            }

            if (g.children) {
                displayMapBuilder(g.children);
            }
        })
    }

    let gdMap = {};

    displayMapBuilder(groups);

    return gdMap;
};

